export const SUPPORTED_BUSINESSES = ["kerakoll", "knauf"];
export const SUPPORTED_CATEGORIES = [
  "created_not_shared",
  "created_shared",
  "visible",
];